import { ChannelType } from 'components/CampaignCreationModal/Types'
import { FacebookAdsMultiStepSchema } from './FacebookAds'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { MultiStepSchema, StepSchema } from './Types'
import { schemas } from 'components/Wizards/schemas/schemas'
import { FacebookPostsMultiStepSchema } from 'components/Wizards/schemas/FacebookPosts'
import { FAQsMultiStepSchema } from 'components/Wizards/schemas/FAQs'
import { GoogleAdsMultiStepSchema } from 'components/Wizards/schemas/GoogleAds'
import { InstagramPostsMultiStepSchema } from 'components/Wizards/schemas/InstagramPosts'
import { InstagramReelsMultiStepSchema } from 'components/Wizards/schemas/InstagramReels'
import { LandingPageMultiStepSchema } from 'components/Wizards/schemas/LandingPage'
import { LinkedInPostsMultiStepSchema } from 'components/Wizards/schemas/LinkedInPosts'
import { NewsletterMultiStepSchema } from 'components/Wizards/schemas/Newsletter'
import { NurtureEmailSequenceMultiStepSchema } from 'components/Wizards/schemas/NurtureEmailSequence'
import { ContentBriefMultiStepSchema } from 'components/Wizards/schemas/ContentBrief'
import { CaseStudyMultiStepSchema } from 'components/Wizards/schemas/CaseStudy'
import { OutlineMultiStepSchema } from 'components/Wizards/schemas/Outline'
import { PressReleaseMultiStepSchema } from 'components/Wizards/schemas/PressRelease'
import { PromotionalEmailMultiStepSchema } from 'components/Wizards/schemas/PromotionalEmailSequence'
import { SMSMessagesMultiStepSchema } from 'components/Wizards/schemas/SMSMessages'
import { TikTokScriptMultiStepSchema } from 'components/Wizards/schemas/TikTokScript'
import { TweetsMultiStepSchema } from 'components/Wizards/schemas/Tweets'
import { TwitterThreadMultiStepSchema } from 'components/Wizards/schemas/TwitterThread'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { BlogPostMultiStepSchema } from 'components/Wizards/schemas/BlogPost'

export const multiStepSchemas: {
  [key in ChannelType | GenerationType]?: MultiStepSchema<ChannelType | GenerationType>
} = {
  [ChannelType.BlogPost]: BlogPostMultiStepSchema,
  [ChannelType.FacebookAds]: FacebookAdsMultiStepSchema,
  [ChannelType.Impact]: {
    steps: [
      schemas[ChannelType.Impact]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.Impact].describe().meta.submitLabel,
        type: ChannelType.Impact,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.Impact].describe().meta,
      channel: ChannelType.Impact,
    },
  },
  [ChannelType.JobDescription]: {
    steps: [
      schemas[ChannelType.JobDescription]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.JobDescription].describe().meta.submitLabel,
        type: ChannelType.JobDescription,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.JobDescription].describe().meta,
      channel: ChannelType.JobDescription,
    },
  },
  [ChannelType.BlogIdeas]: {
    steps: [
      schemas[ChannelType.BlogIdeas]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.BlogIdeas].describe().meta.submitLabel,
        type: ChannelType.BlogIdeas,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.BlogIdeas].describe().meta,
      channel: ChannelType.BlogIdeas,
    },
  },
  [ChannelType.BingAds]: {
    steps: [
      schemas[ChannelType.BingAds]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.BingAds].describe().meta.submitLabel,
        type: ChannelType.BingAds,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.BingAds].describe().meta,
      channel: ChannelType.BingAds,
    },
  },
  [ChannelType.AboutUs]: {
    steps: [
      schemas[ChannelType.AboutUs]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.AboutUs].describe().meta.submitLabel,
        type: ChannelType.AboutUs,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.AboutUs].describe().meta,
      channel: ChannelType.AboutUs,
    },
  },
  [ChannelType.Pricing]: {
    steps: [
      schemas[ChannelType.Pricing]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.Pricing].describe().meta.submitLabel,
        type: ChannelType.Pricing,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.Pricing].describe().meta,
      channel: ChannelType.Pricing,
    },
  },
  [ChannelType.Mission]: {
    steps: [
      schemas[ChannelType.Mission]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.Mission].describe().meta.submitLabel,
        type: ChannelType.Mission,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.Mission].describe().meta,
      channel: ChannelType.Mission,
    },
  },
  [ChannelType.CandidateNurtureSequence]: {
    steps: [
      schemas[ChannelType.CandidateNurtureSequence]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.CandidateNurtureSequence].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.CandidateNurtureSequence].describe().meta,
      channel: ChannelType.CandidateNurtureSequence,
    },
  },
  [ChannelType.ProductLaunchAmazon]: {
    steps: [
      schemas[ChannelType.ProductLaunchAmazon]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ProductLaunchAmazon].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ProductLaunchAmazon].describe().meta,
      channel: ChannelType.ProductLaunchAmazon,
    },
  },
  [ChannelType.ProductLaunchShopify]: {
    steps: [
      schemas[ChannelType.ProductLaunchShopify]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ProductLaunchShopify].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ProductLaunchShopify].describe().meta,
      channel: ChannelType.ProductLaunchShopify,
    },
  },
  [ChannelType.ProductLaunchEtsy]: {
    steps: [
      schemas[ChannelType.ProductLaunchEtsy]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ProductLaunchEtsy].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ProductLaunchEtsy].describe().meta,
      channel: ChannelType.ProductLaunchEtsy,
    },
  },
  [ChannelType.ProductLaunchGoogle]: {
    steps: [
      schemas[ChannelType.ProductLaunchGoogle]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ProductLaunchGoogle].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ProductLaunchGoogle].describe().meta,
      channel: ChannelType.ProductLaunchGoogle,
    },
  },
  [ChannelType.ColdOutboundEmailSequence]: {
    steps: [
      schemas[ChannelType.ColdOutboundEmailSequence]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ColdOutboundEmailSequence].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ColdOutboundEmailSequence].describe().meta,
      channel: ChannelType.ColdOutboundEmailSequence,
    },
  },
  [ChannelType.WarmOutboundEmailSequence]: {
    steps: [
      schemas[ChannelType.WarmOutboundEmailSequence]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.WarmOutboundEmailSequence].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.WarmOutboundEmailSequence].describe().meta,
      channel: ChannelType.WarmOutboundEmailSequence,
    },
  },
  [ChannelType.AmazonAds]: {
    steps: [
      schemas[ChannelType.AmazonAds]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.AmazonAds].describe().meta.submitLabel,
        type: ChannelType.AmazonAds,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.AmazonAds].describe().meta,
      channel: ChannelType.AmazonAds,
    },
  },
  [ChannelType.LinkedInAds]: {
    steps: [
      schemas[ChannelType.LinkedInAds]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.LinkedInAds].describe().meta.submitLabel,
        type: ChannelType.LinkedInAds,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.LinkedInAds].describe().meta,
      channel: ChannelType.LinkedInAds,
    },
  },
  [ChannelType.PinterestAds]: {
    steps: [
      schemas[ChannelType.PinterestAds]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.PinterestAds].describe().meta.submitLabel,
        type: ChannelType.PinterestAds,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.PinterestAds].describe().meta,
      channel: ChannelType.PinterestAds,
    },
  },
  [ChannelType.TikTokAds]: {
    steps: [
      schemas[ChannelType.TikTokAds]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.TikTokAds].describe().meta.submitLabel,
        type: ChannelType.TikTokAds,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.TikTokAds].describe().meta,
      channel: ChannelType.TikTokAds,
    },
  },
  [ChannelType.YoutubeAds]: {
    steps: [
      schemas[ChannelType.YoutubeAds]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.YoutubeAds].describe().meta.submitLabel,
        type: ChannelType.YoutubeAds,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.YoutubeAds].describe().meta,
      channel: ChannelType.YoutubeAds,
    },
  },
  [ChannelType.WelcomeSeries]: {
    steps: [
      schemas[ChannelType.WelcomeSeries]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.WelcomeSeries].describe().meta.submitLabel,
        type: ChannelType.WelcomeSeries,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.WelcomeSeries].describe().meta,
      channel: ChannelType.WelcomeSeries,
    },
  },
  [ChannelType.DidntSignUp]: {
    steps: [
      schemas[ChannelType.DidntSignUp]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.DidntSignUp].describe().meta.submitLabel,
        type: ChannelType.DidntSignUp,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.DidntSignUp].describe().meta,
      channel: ChannelType.DidntSignUp,
    },
  },
  [ChannelType.AbandonedCart]: {
    steps: [
      schemas[ChannelType.AbandonedCart]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.AbandonedCart].describe().meta.submitLabel,
        type: ChannelType.AbandonedCart,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.AbandonedCart].describe().meta,
      channel: ChannelType.AbandonedCart,
    },
  },
  [ChannelType.LostCustomer]: {
    steps: [
      schemas[ChannelType.LostCustomer]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.LostCustomer].describe().meta.submitLabel,
        type: ChannelType.LostCustomer,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.LostCustomer].describe().meta,
      channel: ChannelType.LostCustomer,
    },
  },
  [ChannelType.OnePager]: {
    steps: [
      schemas[ChannelType.OnePager]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.OnePager].describe().meta.submitLabel,
        type: ChannelType.OnePager,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.OnePager].describe().meta,
      channel: ChannelType.OnePager,
    },
  },
  [ChannelType.BattleCard]: {
    steps: [
      schemas[ChannelType.BattleCard]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.BattleCard].describe().meta.submitLabel,
        type: ChannelType.BattleCard,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.BattleCard].describe().meta,
      channel: ChannelType.BattleCard,
    },
  },
  [ChannelType.Testimonial]: {
    steps: [
      schemas[ChannelType.Testimonial]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.Testimonial].describe().meta.submitLabel,
        type: ChannelType.Testimonial,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.Testimonial].describe().meta,
      channel: ChannelType.Testimonial,
    },
  },
  [ChannelType.ProductDemo]: {
    steps: [
      schemas[ChannelType.ProductDemo]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ProductDemo].describe().meta.submitLabel,
        type: ChannelType.ProductDemo,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ProductDemo].describe().meta,
      channel: ChannelType.ProductDemo,
    },
  },
  [ChannelType.PreCallChecklist]: {
    steps: [
      schemas[ChannelType.PreCallChecklist]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.PreCallChecklist].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.PreCallChecklist].describe().meta,
      channel: ChannelType.PreCallChecklist,
    },
  },
  [ChannelType.CallScript]: {
    steps: [
      schemas[ChannelType.CallScript]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.CallScript].describe().meta.submitLabel,
        type: ChannelType.CallScript,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.CallScript].describe().meta,
      channel: ChannelType.CallScript,
    },
  },
  [ChannelType.Research]: {
    steps: [
      schemas[ChannelType.Research]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.Research].describe().meta.submitLabel,
        type: ChannelType.Research,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.Research].describe().meta,
      channel: ChannelType.Research,
    },
  },
  [ChannelType.ReplyTemplates]: {
    steps: [
      schemas[ChannelType.ReplyTemplates]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ReplyTemplates].describe().meta.submitLabel,
        type: ChannelType.ReplyTemplates,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ReplyTemplates].describe().meta,
      channel: ChannelType.ReplyTemplates,
    },
  },
  [ChannelType.HelpDocs]: {
    steps: [
      schemas[ChannelType.HelpDocs]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.HelpDocs].describe().meta.submitLabel,
        type: ChannelType.HelpDocs,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.HelpDocs].describe().meta,
      channel: ChannelType.HelpDocs,
    },
  },
  [ChannelType.ReturnPolicy]: {
    steps: [
      schemas[ChannelType.ReturnPolicy]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ReturnPolicy].describe().meta.submitLabel,
        type: ChannelType.ReturnPolicy,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ReturnPolicy].describe().meta,
      channel: ChannelType.ReturnPolicy,
    },
  },
  [ChannelType.ShippingPolicy]: {
    steps: [
      schemas[ChannelType.ShippingPolicy]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.ShippingPolicy].describe().meta.submitLabel,
        type: ChannelType.ShippingPolicy,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.ShippingPolicy].describe().meta,
      channel: ChannelType.ShippingPolicy,
    },
  },
  [ChannelType.CareInstructions]: {
    steps: [
      schemas[ChannelType.CareInstructions]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.CareInstructions].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.CareInstructions].describe().meta,
      channel: ChannelType.CareInstructions,
    },
  },
  [ChannelType.BillingAndPayments]: {
    steps: [
      schemas[ChannelType.BillingAndPayments]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.BillingAndPayments].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.BillingAndPayments].describe().meta,
      channel: ChannelType.BillingAndPayments,
    },
  },
  [ChannelType.PaymentConfirmation]: {
    steps: [
      schemas[ChannelType.PaymentConfirmation]
        .omit(['include_images'])
        .meta({ title: 'Purpose & Goals', submitLabel: 'Select Images' }) as StepSchema,
      SelectImages.meta({
        submitLabel: schemas[ChannelType.PaymentConfirmation].describe().meta.submitLabel,
      }) as StepSchema,
    ],
    meta: {
      ...schemas[ChannelType.PaymentConfirmation].describe().meta,
      channel: ChannelType.PaymentConfirmation,
    },
  },
  [ChannelType.CaseStudy]: CaseStudyMultiStepSchema,
  [GenerationType.ContentBrief]: ContentBriefMultiStepSchema,
  [ChannelType.FacebookPost]: FacebookPostsMultiStepSchema,
  [ChannelType.FAQs]: FAQsMultiStepSchema,
  [ChannelType.GoogleAds]: GoogleAdsMultiStepSchema,
  [ChannelType.InstagramPosts]: InstagramPostsMultiStepSchema,
  [ChannelType.InstagramReel]: InstagramReelsMultiStepSchema,
  [ChannelType.LandingPage]: LandingPageMultiStepSchema,
  [ChannelType.LinkedInPosts]: LinkedInPostsMultiStepSchema,
  [ChannelType.Newsletter]: NewsletterMultiStepSchema,
  [ChannelType.NurtureEmailSequence]: NurtureEmailSequenceMultiStepSchema,
  [GenerationType.Outline]: OutlineMultiStepSchema,
  [ChannelType.PressRelease]: PressReleaseMultiStepSchema,
  [ChannelType.PromotionalEmailSequence]: PromotionalEmailMultiStepSchema,
  [ChannelType.SMSMessages]: SMSMessagesMultiStepSchema,
  [ChannelType.TikTokScript]: TikTokScriptMultiStepSchema,
  [ChannelType.Tweets]: TweetsMultiStepSchema,
  [ChannelType.TweetThread]: TwitterThreadMultiStepSchema,
}
